export default "__VITE_ASSET__Cn4B01ix__"